// src/scripts/contact/internal/diagnostics.js

import { isBrowser, CONTACT_LOADED_KEY } from './constants.js';
import {
  getInstance,
  getPromise,
  isInitialized,
  getDebugMode
} from './state.js';

const isRealBrowser = (() => {
  try {
    return typeof window !== 'undefined' &&
           typeof document !== 'undefined' &&
           typeof navigator !== 'undefined';
  } catch {
    return false;
  }
})();

const isWindowAvailable = () =>
  isRealBrowser && typeof window !== 'undefined';

export const environment = (() => {
  if (isRealBrowser) return 'browser';
  if (typeof self !== 'undefined' && typeof importScripts === 'function') return 'webworker';
  if (typeof global !== 'undefined' || typeof process !== 'undefined') return 'server';
  return 'unknown';
})();

export function getInternalState() {
  return {
    isInitialized:    isInitialized?.() ?? false,
    hasInstance:      !!getInstance?.(),
    hasPromise:       !!getPromise?.(),
    debugModeEnabled: getDebugMode?.() ?? false,
    globallyLoaded:   isWindowAvailable() && !!window[CONTACT_LOADED_KEY],
    environment,
    moduleVersion:    '1.0.0',               // build‑injected if you wire it up
    timestamp:        new Date().toISOString()
  };
}
